<template>
  <div>
    accident_statistics
  </div>
</template>

<script>
export default {
  name: 'AccidentStatisticsIndex'
}
</script>

<style scoped>

</style>
